import styled from "styled-components";
import Colors from "./../../global/color";

const StyledHeading = styled.div`
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid ${Colors.gold};
`;

const StyledWrapper = styled.div`
  span {
    font-family: "Ogg-Regular";
    font-style: normal;
    font-weight: normal;
    font-size: ${({ size }) =>
      size !== undefined && size === "small" ? "28px" : "35px"};
    line-height: ${({ size }) =>
      size !== undefined && size === "small" ? "30px" : "40px"};
    letter-spacing: 1px;
  }
`;

const StyledWrapperFullWidth = styled.div`
  text-align: center;
  position: relative;
  margin-top: 20px;
  margin-bottom: 30px;
  span {
    display: inline-block;
    background: white;
    letter-spacing: 1px;
    font-size: ${({ clientContext }) =>
      clientContext.isMobile
        ? "26px"
        : clientContext.isTablet
        ? "28px"
        : "36px"};
    line-height: ${({ clientContext }) =>
      clientContext.isMobile
        ? "30px"
        : clientContext.isTablet
        ? "30px"
        : "40px"};
    height: ${({ clientContext }) =>
      clientContext.isMobile
        ? "30px"
        : clientContext.isTablet
        ? "30px"
        : "40px"};
    font-family: Ogg-Regular;
    position: relative;
    padding: 0 16px;
  }
  &:before {
    content: "";
    position: absolute;
    z-index: 0;
    left: 0;
    right: 0;
    top: ${({ clientContext }) =>
      clientContext.isMobile
        ? "15px"
        : clientContext.isTablet
        ? "15px"
        : "20px"};
    height: 1px;
    background: ${Colors.gold};
  }
`;

export { StyledHeading, StyledWrapper, StyledWrapperFullWidth };
